import React from "react";

const Footer: React.FC = () => {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "16px",
        color: "#666",
        fontSize: "12px",
        background: "transparent",
      }}
    >
      ©2022 - 至今 知了管理系统
    </div>
  );
};

export default Footer;
